import uuid from '../utils/uuid';

export default class DOMNodeWrapper {
  constructor({ domNode, origin }) {
    this.id = uuid();
    this.domNode = domNode;
    this.origin = origin;
  }
}
